import React from 'react';
import ListFilteredEvents from '../ListFilteredEvents';
import { Link } from 'react-router';
import style from './style.module.less';
import moment from 'moment';
import 'moment/locale/de';
import { filter, map } from 'lodash';
import ResponsiveImage from '../ResponsiveImage';

const IMAGE_LOCATION = 'termine/';

function Event({ title, title2, subline, date, body, projects, otherEvents, image }) {
    return (
        <div className={style.container}>
            <h1 className={style.title}>
                {title}
            </h1>
            <h2>
                {title2}
            </h2>
            <p>
                {subline}
            </p>
            <p>
                {formatDate(date)}
            </p>
            {projects && projects.length
                ? <p>
                      Projekt:{' '}
                      {map(projects, (project, idx) => {
                          return (
                              <Link key={idx} to={project.path} className={style.project}>
                                  {project.data.title}
                              </Link>
                          );
                      })}
                  </p>
                : null}
            {image ? <ResponsiveImage className={style.image} source={IMAGE_LOCATION + image} /> : null}
            <div dangerouslySetInnerHTML={{ __html: body }} />
            {otherEvents
                ? <div>
                      <h2>---<br></br><br></br>Alle Veranstaltungen dieser Art:</h2>
                      <ListFilteredEvents events={otherEvents} />
                  </div>
                : null}
        </div>
    );
}

function formatDate(date) {
    const d = moment(date);
    const formattedDate = d.format('ddd, DD. MMMM HH:mm');
    return formattedDate;
}

export default Event;



// WEBPACK FOOTER //
// ../components/Event/index.js